import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { formFieldEdit } from '@wix/bi-logger-forms-platform-uou/v2';
import { useBi } from '@wix/form-fields';
import { useRef } from 'react';

import { type FormValues } from '../types';

export const useReportFieldEdit = (form?: Form) => {
  const lastChangedFields = useRef<string[]>([]);
  const bi = useBi();

  return (changedValues: FormValues) => {
    const changedFieldTargets = Object.keys(changedValues);
    const isEditingDifferentFields =
      changedFieldTargets.length !== lastChangedFields.current.length ||
      changedFieldTargets.some(
        (target, index) => target !== lastChangedFields.current[index],
      );

    if (isEditingDifferentFields) {
      lastChangedFields.current = changedFieldTargets;

      changedFieldTargets.forEach((target) => {
        const changedField = form?.fields?.find(
          (field) => field.target === target,
        );
        bi.report(
          formFieldEdit({
            field_id: changedField?.id,
            field_label: changedField?.view?.label,
            field_target: changedField?.target || undefined,
          }),
        );
      });
    }
  };
};
